import { Pipe } from '@angular/core';
import { HDateHour } from '../datatypes/HDateHour';
import { BookingDto } from '../dtos/booking/BookingDto';

@Pipe({
	name: "orderbybookingdto"
})
export class OrderByBookingDto {
	transform(array: Array<BookingDto>, asc: boolean): Array<BookingDto> {
		if (array == null)
			return null;

		array.sort((a: BookingDto, b: BookingDto) => {
			if (asc)
				return OrderByBookingDto.compareAny(a, b);

			return OrderByBookingDto.compareAny(b, a);
		});
		return array;
	}

	public static compareAny(a: BookingDto, b: BookingDto): number {

		return this.validateDateHour(a, b);
	}

	public static validateDateHour(a: BookingDto, b: BookingDto): number {

		let av = a.datetimeStart;
		if (HDateHour.isNullOrNullValue(av))
			av = a.depositStart;

		let bv = b.datetimeStart;
		if (HDateHour.isNullOrNullValue(bv))
			bv = b.depositStart;

		if (HDateHour.isNullOrNullValue(av) && !HDateHour.isNullOrNullValue(bv))
			return OrderByBookingDto.xivato(1, a, b);
		else if (!HDateHour.isNullOrNullValue(av) && HDateHour.isNullOrNullValue(bv))
			return OrderByBookingDto.xivato(-1, a, b);
		else if (HDateHour.isGreaterThan(av, bv))
			return OrderByBookingDto.xivato(1, a, b);
		else if (HDateHour.isMinorThan(av, bv))
			return OrderByBookingDto.xivato(-1, a, b);
		else
			return a.bookingNumber > b.bookingNumber ? 1 : -1;
	}

	public static xivato(valor, a: BookingDto, b: BookingDto) {
		//console.log(a.routeKey + " " + a.pendingMessagesRead + " " + b.routeKey + " " + b.pendingMessagesRead + " -> " + valor)
		return valor;
	}
}
